<template>
    <div class="above">
        <div class="hidden-xs-only">
          <img src="@/assets/yylogo2.png" alt="">
        </div>
        
        <!-- <el-row>
            <el-col :sm="9">

            </el-col>

            <el-col :sm="15">

            </el-col>
        </el-row> -->

        <div class="info">
            <p>咨询电话：{{phone}}</p>
            <p class="hidden-sm-and-up"><span class="space">邮</span>编：264000</p>
            <p>公司地址：{{address}}</p>
            <p class="hidden-xs-only">官方网站：{{site}}</p>
        </div>
        
        <div>
            <img :src="qrcode" alt="">
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            phone: '0535-3931271',
            address: '山东省烟台市莱山区莱盛路136号',
            site: 'www.e-ying.cn',
          qrcode: require('@/assets/qrcode.jpg')
        }
    }
}

</script>
<style lang="scss" scoped>
.above{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: vw(65);
    color: white;
    background: $yyBlue;
    border-bottom: 2px solid rgba(255,255,255,.3);

    div{
        &:first-child{
            img{
                width: vw(294);
                height: vw(85);
            }
            padding: vw(18) vw(82) vw(18) 0;
            border-right: 3px solid;
        }

        &:last-child{
            width: vw(120);
            height: vw(120);

            @media screen and (max-width: 767px){
                width: vp(230);
                height: vp(230);
            }

            img{
                width: 100%;
                height: 100%;
            }
        }
    }

    .info{
        padding-left: vw(82);
        padding-right: vw(134);
        text-align: left;

        @media screen and (max-width: 767px){
            font-size: vp(24);
            max-width: vp(370);
        }

        .space{
            letter-spacing: 2em;
        }
    }
}
</style>